import React from "react";
import { DialogActions, Box } from "@mui/material";
import { platforms } from "./Platforms";

const listStyle = {
    marginBottom: "1rem",
};

function DialogActionWithInstructions(props) {
    return (
        <Box width="100%" display="flex" flexDirection="column">
            <Box>
                <ul
                    style={{
                        listStyleType: "none",
                        display: "flex",
                        flexDirection: "column",
                        margin: 0,
                        padding: 0,
                    }}
                >
                    <li style={listStyle}>{props.action1}</li>
                    <li style={listStyle}>{props.action2}</li>
                    <li style={listStyle}>{props.action3}</li>
                </ul>
            </Box>
        </Box>
    );
}

export default function InstallDialogAction(props) {
    return (
        <>
            <DialogActions>
                {props.platform === platforms.NATIVE && (
                    <DialogActionWithInstructions
                        action1={props.instructionNativeAction1}
                        action2={props.instructionNativeAction2}
                        action3={props.instructionNativeAction3}
                        onSubmit={props.onSubmit}
                        instructionTitle={props.instructionTitle}
                        instructionActionOk={props.instructionActionOk}
                    />
                )}
                {props.platform === platforms.IDEVICE && (
                    <DialogActionWithInstructions
                        action1={props.instructionIdeviceAction1}
                        action2={props.instructionIdeviceAction2}
                        action3={props.instructionIdeviceAction3}
                        onSubmit={props.onSubmit}
                        instructionTitle={props.instructionTitle}
                        instructionActionOk={props.instructionActionOk}
                    />
                )}
                {props.platform === platforms.OTHER && (
                    <Box width="100%" display="flex" flexDirection="column">
                        <Box>
                            {props.instructionNotSupported ||
                                "Unfortunately the install feature is not supported by your browser."}
                        </Box>
                    </Box>
                )}
            </DialogActions>
        </>
    );
}
